var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingButton } from '@mui/lab';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, styled } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessageBox } from '../common';
import { CreatePlan } from './createPlan';
import { useCreatePlanAPI, useUploadDataAPI, useValidatePlanAPI } from './selectors';
var StyledDialogContent = styled(DialogContent)(function (_a) {
  var _b;
  var theme = _a.theme;
  return _b = {
    padding: theme.spacing(4),
    // Layout grid for the inner form (targets lightweight wrappers we add in CreatePlan)
    '& .cinareo-create-plan-grid': {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: theme.spacing(4),
      width: '100%'
    },
    // Make form controls look compact & consistent (without changing CreatePlan props)
    '& .cinareo-create-plan-grid .MuiFormControl-root': {
      width: '100%'
    },
    '& .cinareo-create-plan-grid .MuiInputBase-root': {
      minHeight: 40
    },
    '& .cinareo-create-plan-grid .MuiInputLabel-root': {
      fontWeight: 600,
      fontSize: '0.875rem',
      marginBottom: theme.spacing(0.5)
    },
    '& .cinareo-create-plan-grid .MuiFormLabel-asterisk': {
      fontWeight: 700,
      color: '#d9001b'
    }
  },
  // Responsive adjustments
  _b[theme.breakpoints.down('sm')] = {
    padding: theme.spacing(2),
    '& .cinareo-create-plan-grid': {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(3)
    }
  }, _b;
});
export var CreatePlanDialog = function (_a) {
  var open = _a.open,
    onClose = _a.onClose,
    handleImport = _a.handleImport,
    defaultValues = _a.defaultValues,
    availableIntegrations = _a.availableIntegrations;
  var t = useTranslation(['myPlans', 'translation']).t;
  var createPlanData = useCreatePlanAPI()[0];
  var validatePlanData = useValidatePlanAPI()[0];
  var uploadData = useUploadDataAPI()[0];
  var _b = useState(true),
    isCreateDisabled = _b[0],
    setIsCreateDisabled = _b[1];
  return _jsx(Dialog, __assign({
    open: open,
    onClose: onClose
  }, {
    children: _jsxs(Box, {
      children: [_jsx(DialogTitle, __assign({
        variant: "h2",
        sx: {
          px: 4
        }
      }, {
        children: t('createPlanDialogTitle', {
          defaultValue: 'Create a new plan'
        })
      })), _jsxs(StyledDialogContent, {
        children: [_jsx(Typography, __assign({
          variant: "body1",
          sx: {
            mb: 4
          }
        }, {
          children: t('createPlanDialogDescription', {
            defaultValue: 'Enter your plan details below:'
          })
        })), _jsx(ErrorMessageBox, {
          errors: [validatePlanData.error, createPlanData.error, uploadData.error]
        }), _jsx(CreatePlan, {
          handleImport: handleImport,
          defaultValues: defaultValues,
          formId: "create-plan-form",
          showSubmitButton: false,
          availableIntegrations: availableIntegrations,
          isCreateDisabled: setIsCreateDisabled
        })]
      }), _jsxs(DialogActions, {
        children: [_jsx(Button, __assign({
          variant: "outlined",
          onClick: onClose
        }, {
          children: t('action.cancel', {
            ns: 'translation',
            defaultValue: 'Cancel'
          })
        })), _jsx(LoadingButton, __assign({
          variant: "contained",
          type: "submit",
          form: "create-plan-form",
          disabled: isCreateDisabled,
          loading: createPlanData.requesting || validatePlanData.requesting || uploadData.requesting
        }, {
          children: t('action.create', {
            ns: 'translation',
            defaultValue: 'CREATE'
          })
        }))]
      })]
    })
  }));
};